import SystemMessage from "components/SystemMessage";
import { ErrorCircleColored } from "components/icons/generated";
import LinkButton from "ds/components/Button/LinkButton";

const NotFoundPage = () => (
  <SystemMessage
    title="Page not found"
    message={
      <>
        Sorry, we couldn't find what you're looking for. If you're certain something should be here,
        you may try reloading the page.
      </>
    }
    icon={ErrorCircleColored}
  >
    <LinkButton variant="primary" size="medium" href="/">
      Go to Homepage
    </LinkButton>
  </SystemMessage>
);

export default NotFoundPage;
